<template>
  <div class="container-xxl">
    <template v-if="!auth.estaLogado()">
      <div class="col-md-10 col-lg-8 col-xl-6 col-xxl-4 offset-md-1 offset-lg-2 offset-xl-3 offset-xxl-4 py-3">
        <Titulo :sombra="false" titulo='Recuperação de senha' icon="" posicao="center" />
        <fieldset>
          <form id="login" @submit.prevent="enviar_cod_email()">
            <InputText classDiv="col-md-12" placeholder="" nome="email" tipo="email" label="Email de recuperação *"
              mask="email" tamanho="sm" :required="true" v-model="user.email" />

            <div class="d-grid gap-2 mx-auto">
              <button type="submit" class="btn btn-info text-white btn-lg">
                Enviar código de recuperação para email
                <Spinner :visivel="false" id="load" />
              </button>
            </div>
          </form>
          <div class="row">
            <div class="col-6 col-md-4 d-grid gap-2 mx-auto">
              <a href="/#formulario" class="btn btn-light mt-2 btn-block">Cadastre-se</a>
            </div>
            <div class="col-6 col-md-4 d-grid gap-2 mx-auto">
              <router-link to="/login" class="btn btn-light mt-2 btn-block">Login</router-link>
            </div>
          </div>
        </fieldset>
      </div>
    </template>
    <template v-else>
      <div class="col-md-10 offset-md-1 py-3 mt-5">
        <boas-vindas :nome="auth.nomeUser" />
      </div>
    </template>
  </div>
</template>

<script>
import { bloqueia_campos, mensagem_request } from '@/assets/js/functions';
import InputText from '@/components/form/InputText.vue';
import Spinner from '@/components/Spinner.vue';
import Titulo from '@/components/Titulo.vue';
import { toastr } from '@/plugins/toast';
import { api } from '@/services/api';
import { AuthStore } from '@/stores/Auth';

export default {
  name: 'RecuperarSenha',
  data() {
    return {
      user: {
        verifica_email: localStorage.getItem('email')
      },
      auth: AuthStore(),
      disable: false,
      verifica_envio: (localStorage.getItem('verifica_envio') ? localStorage.getItem('verifica_envio') : false)
    }
  },
  components: {
    InputText,
    Spinner,
    Titulo,
  },
  methods: {
    async enviar_cod_email() {
      bloqueia_campos()
      try {
        const data = await api.post('login/pass_recovery', this.user)
        mensagem_request(data)
        if (data.status == 200) {
          localStorage.setItem('verifica_envio', true)
          this.verifica_envio = true
          localStorage.setItem('email', this.user.email)
          this.$router.push('confimrar_codigo');
        }
        this.user.verifica_email = localStorage.getItem('email')
      } catch (error) {
        toastr.erro("Erro ao fazer o login.");
      }
      bloqueia_campos(false)
    },
  },
  mounted() {
    localStorage.removeItem('verifica_envio')
    localStorage.removeItem('email')
    
    if(this.auth.estaLogado()){
      this.$router.push('login')
    }
  },
}
</script>

<style scoped></style>